import dispatcher from '../dispatcher';
import scrollStore from '../scroll/scroll.store';
import resizeStore from '../resize/resize.store';
import * as utils from '../utils';
import * as calcProperty from '/src/assets/scripts/modules/utils/calcProperty';
import TweenMax from 'gsap/all';

var hiddenElements = [];
var container = null;

var _getOnScreen = function() {
	var scrolled = scrollStore.getData().top;
	var onScreenElements = [];
	var elements;
	var containerElements;

	if (container) {
		elements = container.getElementsByClassName('jhp');
		containerElements = container.getElementsByClassName('jhpp');
	} else {
		elements = document.getElementsByClassName('jhp');
		containerElements = document.getElementsByClassName('jhpp');
	}

	elements = Array.prototype.slice.call(elements);
	Array.prototype.forEach.call(containerElements, function(cnt) {
		var newElements = Array.prototype.slice.call(cnt.children);
		elements = elements.concat(newElements);
	});

	elements.forEach(function(el) {
		var offset = utils.offset(el);
		el._offsetTopCH = offset.top;
		el._offsetLeftCH = offset.left;

		calcProperty.attach(el, {
			namespace: 'content-hide',
			setStyles: true
		})
	});

	if (container && container.tagName.toLowerCase() !== 'main') {
		onScreenElements = elements;
	} else {
		elements.forEach(function(el) {
			if (scrolled + resizeStore.getData().height >= el._offsetTopCH &&
				scrolled <= el._offsetTopCH + el.clientHeight) {
				onScreenElements.push(el);
			}
		});
	}

	onScreenElements = onScreenElements.sort(function(a, b) {
		return a._offsetTopCH >= b._offsetTopCH;
	});

	return onScreenElements;
}

var _hide = function(speed, way) {
	var onScreenElements = _getOnScreen();
	var ww = resizeStore.getData().width;
	var wh = resizeStore.getData().height;
	var scrolled = scrollStore.getData().top;
	var m = 1;
	var delays = [];
	var maxDelay = 0;

	hiddenElements = onScreenElements;

	if (container.tagName.toLowerCase() !== 'main') {
		m = 0;
	}

	onScreenElements.forEach(function(el) {
		el.style.webkitTransitionProperty =
			el.style.transitionProperty = 'none';
	});

	if (speed === 0) {
		onScreenElements.forEach(function(el) {
			TweenMax.to({x: 0, o: 1}, 0.45, {
				x: 50 * way,
				o: 0,
				ease: window._easings.ease,
				onUpdate: function() {
					var tween = this;
					d.elements.forEach(function(el) {
						el._calcProperty.set({
							property: ['x', 'opacity'],
							namespace: 'content-hide',
							value: [tween._targets[0].x, tween._targets[0].o]
						});
					});
				}
			});
		});
	} else {
		onScreenElements.forEach(function(el) {
			var found = false;

			delays.forEach(function(d, index) {
				if (Math.abs(d.offset - el._offsetTopCH) < 10) {
					found = index;
					d.elements.push(el);
				}
			});

			if (found === false) {
				delays.push({
					offset: el._offsetTopCH,
					elements: [el]
				});
			}
		});

		delays.sort(function(a, b) {
			return a.offset > b.offset;
		});

		maxDelay = (delays.length - 1);

		delays.forEach(function(d, index) {
			TweenMax.to({x: 0, o: 1}, 0.45, {
				x: 150 * way * m,
				o: 0,
				ease: Power3.easeIn,
				delay: index * (0.3 / maxDelay),
				onUpdate: function() {
					var tween = this;
					d.elements.forEach(function(el) {
						el._calcProperty.set({
							property: ['x', 'opacity'],
							namespace: 'content-hide',
							value: [tween._targets[0].x, tween._targets[0].o]
						});
					});
				}
			});
		});
	}
}

var _show = function(speed, way) {
}

var _init = function() {
	var way;
	dispatcher.subscribe(function(e) {
		if (e.type === 'content:hide') {
			way = e.way !== undefined ? e.way : 1;
			container = e.container || null;
			_hide(1, 1);
		}
		if (e.type === 'content:instant-hide') {
			container = e.container || null;
			_hide(0, 0);
		}
		// if (e.type === 'content:show') {
		// 	way = e.way !== undefined ? e.way : 1;
		// 	container = e.container || null;
		// 	_show(1, 1);
		// }
		// if (e.type === 'content:instant-show') {
		// 	container = e.container || null;
		// 	_show(0, 0);
		// }
		if (e.type === 'content:replaced') {
			hiddenElements = [];
		}
	});
}

_init();